import { useContext } from 'react'
import { GlobalSearchContext } from '../context/GlobalSearchContext'
import useGoBackState from 'shared/hooks/useGoBackState'
import {
  GlobalSearch,
  IconInvoice,
  getFormattedDate,
  getFormattedPrice,
} from '@bbl-digital/snorre-v2'
import { ddmmyy } from 'shared/constants/dateformats'
export const InvoiceSearchHits = () => {
  const { loading, invoiceHits } = useContext(GlobalSearchContext)

  const { push } = useGoBackState()

  const hasInvoiceHits = invoiceHits?.hits?.length

  const goToInvoice = (id: string) => {
    push(`/okonomi/faktura/arkiv/${id}`)
  }

  if (loading || !hasInvoiceHits) return null

  const Hits = () => {
    return invoiceHits.hits.map((item) => {
      const highlights = item?.highlights?.length ? item.highlights : []

      const subtitle = () => {
        const date = item.dueDate
          ? `Forfall: ${getFormattedDate(item.dueDate, ddmmyy)}`
          : ''
        const amount = item.amount
          ? `Beløp: ${getFormattedPrice(item.amount)},-`
          : ''

        return `${date}, ${amount}`
      }
      const invoiceNumberIsNumber = !isNaN(Number(item.invoiceNumber))

      const labelWithInvoiceNumber = `${
        invoiceNumberIsNumber ? `#${item.invoiceNumber}` : item.invoiceNumber
      } ${item.supplierName || item.invoiceNumber} `

      return (
        <GlobalSearch.Item
          key={item.id}
          icon={<IconInvoice backgrounded colorVariant="primary" />}
          label={labelWithInvoiceNumber}
          subtitle={subtitle()}
          highlights={highlights}
          options={{
            renderHighlightsAsHtml: true,
            takeHighlights: 1,
            takeHighlightsValues: 1,
            lineClampSubtitle: 'line-clamp-3',
          }}
          onClick={() => goToInvoice(item.id)}
        />
      )
    })
  }

  return (
    <GlobalSearch.Group label="Faktura" title="Faktura">
      <Hits />
    </GlobalSearch.Group>
  )
}
